import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/core/services/api.service';
import { config } from 'src/app/config';
import { BehaviorSubject, Subject } from 'rxjs';
import { LoaderService } from 'src/app/core/services/loader.service';
import { Router } from '@angular/router';
import { finalize } from 'rxjs/operators';

@Injectable()
export class CandidateService {
  files = new BehaviorSubject<any>([]);
  canDownload = new BehaviorSubject<boolean>(true);

  constructor(
    private api: ApiService,
    private loaderService: LoaderService,
    private router: Router
  ) {}

  getCandidates() {
    return this.api.get(config.partialUrls.candidates, {});
  }

  getCandidate(id) {
    return this.api.get(`${config.partialUrls.candidates}/${id}`, {});
  }

  getSkills() {
    return this.api.get(config.partialUrls.skills, {});
  }

  createCandidate(candidate) {
    return this.api.post(config.partialUrls.create, candidate);
  }

  deleteCandidate(id) {
    return this.api.post(`${config.partialUrls.deleteCandidate}/${id}`, {});
  }

  updateCandidate(id, candidate) {
    return this.api.put(
      `${config.partialUrls.updateCandidate}/${id}`,
      candidate
    );
  }

  incrementDownload(link: string) {
    this.api
      .get(`${config.partialUrls.resumeDownloadsCounter}`, {})
      // .pipe(finalize(() => this.getTotalDownloads()))
      .subscribe((res) => {
        this.getTotalDownloads();
        window.location.href = link;
      });
  }

  sendEmailNotification() {
    this.api.get(`${config.partialUrls.emailNotification}`, {});
  }

  getTotalDownloads() {
    this.api
      .get(`${config.partialUrls.resumeDownloadsCountSend}`, {})
      .subscribe((res) => {
        // console.log('SKIP11', res.body.Count >= res.body.DownloadLimit);
        if (res.body.Count >= res.body.DownloadLimit && !res.body.SkipLogout) {
          localStorage.removeItem('user');
          window.location.href = '/auth/login';
        }
        // if (
        //   res.body.Count >= res.body.DownloadLimit &&
        //   localStorage.getItem('extra_allowed_date') !=
        //     new Date().toLocaleDateString('en-CA')
        // ) {
        //   localStorage.removeItem('user');
        //   window.location.href = '/auth/login';
        // }
      });
  }
}
